import PropTypes from "prop-types"

import { Typography, Alert, Snackbar } from "@mui/material"

export const Error = ({ error, resetError }) => {
  return error ? (
    <Snackbar
      open
      onClose={resetError}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert variant="filled" sx={{ whiteSpace: "pre-line", padding: "10px 70px" }} severity="error">
        {error.message && <Typography>{error.message}</Typography>}
        {error.status && <Typography>HTTP Status Code: {error.status}</Typography>}
        {error.statusText && <Typography>HTTP Status: {error.statusText}</Typography>}
        {error.payload?.errorCode && <Typography>Error Code: {error.payload.errorCode}</Typography>}
        {error.payload?.message && <Typography>Message: {error.payload.message}</Typography>}
      </Alert>
    </Snackbar>
  ) : (
    <></>
  )
}

Error.propTypes = {
  error: PropTypes.object,
  resetError: PropTypes.func
}
